import { render, staticRenderFns } from "./TaskMonitor.vue?vue&type=template&id=22298ba0&scoped=true"
import script from "./TaskMonitor.vue?vue&type=script&lang=js"
export * from "./TaskMonitor.vue?vue&type=script&lang=js"
import style0 from "./TaskMonitor.vue?vue&type=style&index=0&id=22298ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22298ba0",
  null
  
)

export default component.exports